// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"717":"5578c3b7","845":"d7f51ade"}[chunkId] + ".chunk.js";
};